import gql from 'graphql-tag';

export const GET_USER_STATS = gql`
  query GetStats($input: UserStatsQuery!) {
    getStats(input: $input) {
      labels
      values
    }
  }
`;
